import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { config } from '../config';

function createSafeClient(): SupabaseClient | null {
  const { url, anonKey } = config.supabase;
  if (!url || !anonKey) {
    console.warn('[Supabase] Missing URL or anon key – Supabase features disabled.');
    return null;
  }
  return createClient(url, anonKey);
}

export const supabase = createSafeClient();
